import "./App.css";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthWrapper from "./components/AuthWrapper";

Amplify.configure({ ...awsExports });

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="*" element={<AuthWrapper />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
